import { createSelectors as c } from "@waitroom/state";
import { createSelector as s } from "reselect";
import { create as p } from "zustand";
const n = p()(() => ({
  participants: {}
})), r = c(n), P = (a) => {
  r.setState((t) => ({
    ...t,
    participants: a
  }));
}, u = (a, t) => {
  r.setState((e) => ({
    ...e,
    participants: { ...e.participants, [a]: t }
  }));
}, d = (a) => r.setState((t) => {
  const { [a]: e, ...i } = t.participants;
  return {
    ...t,
    participants: i
  };
}), f = (a) => s(
  (t) => t.participants,
  (t) => t[a]
);
export {
  f as makeSelectorParticipantMetadata,
  d as removeParticipant,
  u as updateParticipant,
  P as updateParticipants,
  r as useParticipantsStore
};
